export class AgendaRequest {
  public constructor(init?: Partial<AgendaRequest>) {
    Object.assign(this, init);
  }
  CompanyId: number;
  Year: number;
  DeclarationName: string;
}
